export default __webpack_public_path__ + "static/media/blank_video.6ddef010.mp4";